<template>
  <div :class="isApp == true ? '' : 'content'">
    <Header></Header>
    <div class="main" v-show="isApp == false">
      <MainLeft></MainLeft>
      <div class="main_content">
        <div class="navigation">
          {{ $t('teaching.home') }}>>{{ $t('nav.game') }}>>{{ isTitle }}
        </div>
        <div class="big_bod">
          <!-- 标题 -->
          <div class="question_title subb">
            <div :class="
              questionActive == index
                ? 'question_item_title_sub'
                : 'question_item_title'
            " v-for="(item, index) in questionList" :key="index" @click="changeQusetion(item, index)">
              {{ item.title }}
            </div>
          </div>

          <div class="small_bod">

            <div class="bggame" :style="'min-height:' + screenHeight + 'px'">
              <div>
                <a href="https://h5.tiger777.com" target="_blank" class="buttonlang">{{ $t('nav.t3') }}
                </a>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>


    <div class="isapp" v-show="isApp == false ? false : true">
      <div class="isapp_big_bod">
        <div class="question_title subb">
          <div :class="
            questionActive == index
              ? 'isapp_question_item_title_sub'
              : 'isapp_question_item_title'
          " v-for="(item, index) in questionList" :key="index" @click="changeQusetion(item, index)">
            {{ item.title }}
          </div>
        </div>
        <div class="isapp_small_bod">

          <div class="bggame" :style="'min-height:' + screenHeight + 'px'">
            <div>
              <a href="https://h5.tiger777.com" target="_blank" class="buttonlangapp">{{ $t('nav.t3') }}
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
    <Login-pop ref="LoginPop"></Login-pop>
    <Footer></Footer>
    <router-view />
  </div>
</template>
<script>
import "../assets/h5/client.css";
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      isbuyIconEn: true,
      isbuyIconZh: false,
      questionActive: 0,
      isTitle: "",
      isQuestion: true,
      isSuspension: false,
      visible: false,
      isLoginShow: false,

      screenHeight: 300, // 屏幕高度,
      showQuestion: [],
      suspensionList: [],
    };
  },
  computed: {
    ...mapState({
      hasLogin(state) {
        return state.hasLogin;
      },
      isApp(state) {
        return state.isApp;
      },
    }),
    questionList() {
      return [
        {
          title: this.$t("nav.game"),
        },
        // {
        //   title: this.$t("client.suspensions"),
        //   total: [
        //     {
        //       userId: "jqqqqqqq",
        //       timeStart: "2022/2/28",
        //       timeEnd: "终止契约",
        //       reason: "大量新申請帳號破壞遊戲秩序者",
        //     },
        //     {
        //       userId: "aaaaaa",
        //       timeStart: "2022/2/28",
        //       timeEnd: "终止契约",
        //       reason: "大量新申請帳號破壞遊戲秩序者",
        //     },
        //   ],
        // },
        // {
        //   title: this.$t("client.report"),
        // },
      ];
    },
  },
  created() {
    this.showPop();
    this.questionShow();
    this.changeIcon();
  },
  methods: {

    goDown() {
      this.$router.push('/Down')
    },
    changeIcon() {
      let lang = localStorage.getItem("lang");
      if (lang == "en") {
        this.isbuyIconEn = true;
        this.isbuyIconZh = false;
      }
      if (lang == "zh") {
        this.isbuyIconEn = false;
        this.isbuyIconZh = true;
      }
    },
    showPop() {
      // console.log("1");
      this.visible = true;
    },
    changeLogin() {
      this.isLoginShow = false;
    },
    changeQusetion(e, index) {
      console.log("questionList", e);
      this.questionActive = index;
      this.isTitle = e.title;
      if (index == 0) {
        this.showQuestion = e.total;
        this.isQuestion = true;
        this.isSuspension = false;
      }
      if (index == 1) {
        this.isSuspension = true;
        this.isQuestion = false;
        this.suspensionList = e.total;
      }
      if (index == 2) {
        if (this.hasLogin == false) {
          this.$refs.LoginPop.showLogin();
        }
      }
    },
    questionShow() {
      // console.log("----", this.questionList[0].total);
      this.showQuestion = this.questionList[0].total;
    },
  },
};
</script>
<style lang="less" scoped="">
// .content {
//   width: 100%;
//   background: #ad0000
//     url("https://www.jinjinjin777.com/static/images/bg-pc-head.jpg") center top
//     no-repeat;
//   background-size: 100% auto;
// }
.main_content {
  width: 75%;
  float: right;
}

.buttonlang {
  font-size: 2rem;
  color: aliceblue;
  font-weight: bold;
  background-image: linear-gradient(180deg, #f0d34c, #cf9e35);
  border-radius: 0.625rem;
  line-height: 3.125rem;
  height: 3.125rem;
  margin: 0 auto;
  padding: 0.375rem;
  width: 90%;
  padding: 0.6rem;
}
.buttonlangapp {
  font-size: 1.5rem;
  color: aliceblue;
  font-weight: bold;
  background-image: linear-gradient(180deg, #f0d34c, #cf9e35);
  border-radius: 0.625rem;

  height: 2.8rem;
  margin: 0 auto;
  padding: 0.2rem;
  width: 70%;
  padding: 0.3rem;
}


.button::after {
  border: none; //去除边框
}

.bggame {
  display: flex;
  flex-direction: column;
  background: url('../assets/index/index-background.jpg');
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

}

.bgbutton() {}

.login_pop {
  position: relative;
  position: fixed;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 25rem;
  height: 15.625rem;
  background-color: black;
  border: 0.125rem solid #e1aa3f;
  border-radius: 0.3125rem;
}

.login_title {
  background: #ffdb6b;
  background-image: linear-gradient(180deg,
      #dea339 0%,
      #f9cc4a 20%,
      #ffdb6b 35%,
      #ffdb6b 55%,
      #ce9631 80%,
      #8c5c0d 100%);
  color: #2e0100;
  font-weight: 700;
  font-size: 1.25rem;
  height: 2.25rem;
  line-height: 2.25rem;
}

.login_msg {
  width: 23.75rem;
  background-color: rgb(60, 0, 0);
  height: 12.5rem;
  margin: 0 auto;
}

.login_com {
  padding-top: 1.875rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.login_as {
  color: #f9cc4a;
  margin-right: 0.625rem;
}

.login_input input {
  height: 1.875rem;
  width: 12.5rem;
}

.login_in {
  color: #000;
  background-image: linear-gradient(#d5ff70 0%,
      #3b8c00 50%,
      #358000 50%,
      #296100 90%,
      #1e4600 100%);
  border: 0.125rem solid #a2750a;
  font-size: 1.125rem;
  padding: 0.375rem 0rem;
  font-weight: 600;
  width: 9.375rem;
  margin: 0 auto;
  margin-top: 1.25rem;
  border-radius: 0.3125rem;
}

.login_guanbi {
  position: absolute;
  top: -0.9375rem;
  right: -0.9375rem;

  .el-icon-error {
    font-size: 2.1875rem;
  }
}

.big_bod {
  width: 55.5rem;
  // height: 50rem;
  background-color: rgb(188, 152, 30);
  border: 0.125rem solid white;
  border-radius: 0.3125rem;
}

.question_title {
  display: flex;
}

.question_item_title {
  padding: 0.625rem 1.25rem;
  // border: 0.0625rem solid white;
  background: #a58416;
  color: #3a1302;
  font-size: 1.125rem;
}

.question_item_title_sub {
  padding: 0.625rem 1.25rem;
  font-size: 1.125rem;
  color: #3a1302;
  color: white;
  background-image: linear-gradient(#eade38 0%, #ccb127 50%, #bc981e 100%);
}

.small_bod {
  background-color: rgb(215, 206, 176);
  width: 96%;
  margin: 0 auto;
  padding: 0.3125rem;
  border: 0.125rem solid #3a1302a9;
  border-radius: 0.3125rem;
  margin-bottom: 0.625rem;
  margin-top: 0.625rem;
}

/deep/.el-collapse-item__header {
  background-image: linear-gradient(#fff084 0%, #ffcd48 100%);
  border: solid 0.0625rem #cc890f;
  border-radius: 0.5rem;
  color: #5b0606;
  font-weight: bold;
  width: 80%;
  margin: 0.625rem auto;
  padding: 0 0.625rem;
}

/deep/.el-collapse-item__content {
  background-color: rgb(215, 206, 176);
  padding-bottom: 0.625rem;
}

.suspension_search {
  display: flex;
  flex-direction: row;
  justify-items: flex-end;
}

.suspension_search input {
  height: 1.875rem;
}

.suspension_search button {
  height: 1.875rem;
  width: 1.875rem;
}

.suspension_list {
  margin-top: 1.25rem;
  display: flex;
  flex-direction: row;
  // justify-content: space-between;
  background-color: rgb(166, 144, 76);
  padding: 0.625rem 1.25rem;
}

.suspension_list_item {
  display: flex;
  flex-direction: row;
  padding: 0.725rem 1.25rem;
  border-bottom: 0.0625rem solid rgb(166, 144, 76);
  // justify-content: space-between;
}

.suspension_list_small {
  width: 20%;
  color: #6d2701;
}

.suspension_list_small_sub {
  width: 20%;
  color: white;
}

.suspension_list_big {
  width: 40%;
  color: red;
}

.suspension_list_big_sub {
  width: 40%;
  color: white;
}

.showQuestion_item {
  text-align: left;
  margin-left: 6.25rem;
}

/deep/ .el-collapse-item__header {
  height: auto;
  padding: 0.625rem 0;
  padding-left: 0.9375rem;
  line-height: normal;
  text-align: left;
}

/deep/ .el-pager li {
  color: white;
  min-width: 1.5938rem;
  background-color: rgb(120, 2, 0);
}

/deep/ .el-pagination button:disabled {
  min-width: 1.5938rem;
  color: #C0C4CC;
  background-color: rgb(97, 0, 1);
  cursor: not-allowed;
}

/deep/ .el-pagination .btn-next,
.el-pagination .btn-prev {
  min-width: 1.5938rem;
  background: rgb(189, 29, 29);
  background-size: 1rem;
  cursor: pointer;
  margin: 0;
  color: white;
}

/deep/ .el-pager li.active {
  min-width: 1.5938rem;
  color: #409EFF;
  cursor: default;
  background-color: rgb(120, 2, 0);
}

/deep/ .el-pagination .btn-prev {
  color: white;
  background: #bd1d1d;
  background-size: 1rem;
  cursor: pointer;
  margin: 0;
}

/deep/ .el-collapse-item__header {
  font-size: 0.9375rem;
  font-weight: normal;
}

.suspension_fenye {
  margin-top: 0.825rem;
}

.xia_left_center img {
  width: 5.9375rem;
  height: 1.9375rem;
}

.xia_left_btm img {
  width: 5.9375rem;
  height: 1.9375rem;
}

.xiazaitu {
  width: 5.9375rem;
  height: 1.9375rem;
}
</style>
